import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";

// Autocomplétion d'adresses via la Base Adresse Nationale (data.gouv.fr) —
// gratuite, sans clé, couvre toute la France et renvoie les coordonnées GPS.
export function AddressAutocomplete({ value, onChange, onSelect, placeholder, testid, listTestid }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef();

  useEffect(() => { setQ(value || ""); }, [value]);

  const search = (text) => {
    setQ(text);
    onChange && onChange(text);
    clearTimeout(timer.current);
    if (text.trim().length < 3) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try {
        const r = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(text)}&limit=6`);
        const d = await r.json();
        setResults(d.features || []);
        setOpen(true);
      } catch { setResults([]); }
    }, 300);
  };

  const pick = (f) => {
    const label = f.properties.label;
    setQ(label);
    setOpen(false);
    setResults([]);
    onSelect && onSelect({ label, lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0] });
  };

  return (
    <div className="relative">
      <MapPin size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gold pointer-events-none z-10" />
      <input
        data-testid={testid}
        value={q}
        onChange={(e) => search(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className="w-full rounded-md border border-white/15 bg-ink pl-9 pr-3 py-2.5 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
      />
      {open && results.length > 0 && (
        <ul data-testid={listTestid} className="absolute z-40 mt-1 w-full rounded-md border border-white/15 bg-panel shadow-2xl max-h-64 overflow-auto">
          {results.map((f, i) => (
            <li
              key={f.properties.id || i}
              onMouseDown={() => pick(f)}
              className="px-4 py-2.5 text-sm text-white/80 hover:bg-gold/10 hover:text-white cursor-pointer border-b border-white/5 last:border-0"
            >
              {f.properties.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
